import { Component, OnInit, Inject } from '@angular/core';
import { ComputeWithMetaDataDto } from '@sharedcommon/rest/data.restservice';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

/**
 * Dialog component to show a list of equations which has a specific capped nutirent code
 */
@Component({
  templateUrl: './rawmaterial-facultative-error-popin.component.html'
})
export class RawMaterialFacultativeErrorPopin implements OnInit {

  computeWithMeta: ComputeWithMetaDataDto ;

  constructor(
    private readonly dialogRef: MatDialogRef<RawMaterialFacultativeErrorPopin>,
    @Inject(MAT_DIALOG_DATA) public data: {
      args: ComputeWithMetaDataDto
    }
  ) {
  }

  ngOnInit() {
    /* If execution error here that means that args is not well configured */
    this.computeWithMeta = this.data.args ;
  }

   closeDialog() {
    this.dialogRef.close();
  }
}
